import { OfficeThemeMode } from '@office-start/theming-types';
import { useThemeMode } from './useThemeMode';
export function useIsDarkMode() {
    var themeMode = useThemeMode();
    return themeMode == OfficeThemeMode.dark;
}
//# sourceMappingURL=useIsDarkMode.js.map